import {FunctionComponent, useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import {AuthenticationService} from '@/services/authentication';
import {ErrorPresenter} from '../error-presenter';

const AdvisorProfileError: FunctionComponent = () => {
  const {t} = useTranslation();

  const handleLogout = useCallback(async () => {
    await AuthenticationService.getInstance().logout();
  }, []);

  return (
    <ErrorPresenter
      data-testid="advisor-profile-error"
      title={t('components.advisor-profile-error.title')}
      action={{
        label: t('components.advisor-profile-error.action'),
        trackingKey: WEB_CLICK_TRACKING_KEY.ADVISOR_PROFILE_ERROR_LOGOUT,
        onClick: handleLogout,
      }}
    >
      <p>{t('components.advisor-profile-error.message-line1')}</p>
      <p>{t('components.advisor-profile-error.message-line2')}</p>
    </ErrorPresenter>
  );
};

export default AdvisorProfileError;
